import { /*FetchBaseQueryError,*/ createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { createHandleQueryErrorAndRetry } from '../app/rtkQueryErrorHandler';
import { RootState } from '../app/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export type PinModalCategory = 'user' | 'ownUser' | 'institution'
export interface PinScreenPosition { x: number; y: number }
export interface PinHeroInfo { screenX: number; screenY: number; iconUrl: string; iconSize: number }

export type ActivePinModal = { data: any; category: PinModalCategory; pinScreenPosition?: PinScreenPosition; heroInfo?: PinHeroInfo; preview?: boolean }

interface UtilityState {
  showBottomSheet: boolean;
  activePinModal: ActivePinModal | null;
}

const initialState: UtilityState = {
  showBottomSheet: false,
  activePinModal: null,
};

export const utilitySlice = createSlice({
  name: 'utility',
  initialState,
  reducers: {
    setBottomSheetState(state, action: PayloadAction<boolean>) {
      state.showBottomSheet = action.payload;
    },
    setActivePinModal(state, action: PayloadAction<ActivePinModal | null>) {
      state.activePinModal = action.payload;
    },
  },
});

export const utilityApi = createApi({
    reducerPath: 'utilityApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['WebPageMetaData', 'YoutubeMetaData'],
    endpoints: (builder) => ({
        getWebPageMetaData: builder.query<any, string>({
            query: (url) => {
                const urlEncoded = encodeURIComponent(url);
                const qry = `/api/get/webpagemetadata/?url=${urlEncoded}`
                return qry
            },
            providesTags: (result, response, updated) => {
                return [{ type: 'WebPageMetaData', id: updated }]
            }
        }),
        getYoutubeMetaData: builder.query<any, string>({
            query: (url) => {
                const urlEncoded = encodeURIComponent(url);
                const qry = `/api/get/youtubemetadata/?url=${urlEncoded}`
                return qry
            },
            providesTags: (result, response, updated) => {
                return [{ type: 'YoutubeMetaData', id: updated }]
            }
        }),

        logToBackEnd: builder.mutation<void, { context: string; message: string, version: string }>({
            query: (args) => ({
                url: '/api/log', // Adjust this to match your backend route
                method: 'POST',
                body: args,
            }),
        })


    })
})
// --- Extract the initiate action creator for your logging mutation ---
// export const logToBackEndInitiate = utilityApi.endpoints.logToBackEnd.initiate;

// // --- Create the specific onQueryStarted handler instance, typed with RootState and the logger ---
// export const handleApiQueryErrorAndRetry = createHandleQueryErrorAndRetry<RootState>();

export const { useGetWebPageMetaDataQuery, useGetYoutubeMetaDataQuery, useLogToBackEndMutation } = utilityApi

export const {
  setBottomSheetState,
  setActivePinModal,
} = utilitySlice.actions;

export const utilityReducer = utilitySlice.reducer;